import { render, staticRenderFns } from "./jobsNeedList.vue?vue&type=template&id=04c17b97"
import script from "./jobsNeedList.vue?vue&type=script&lang=js"
export * from "./jobsNeedList.vue?vue&type=script&lang=js"
import style0 from "./jobsNeedList.vue?vue&type=style&index=0&id=04c17b97&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports